import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const visitorId = () => {
  let id = localStorage.getItem("jt-visitor-id");
  if (!id) { id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9-]/g, ""); localStorage.setItem("jt-visitor-id", id); }
  return id;
};

// Records one anonymous page view per route change (no personal details) for the admin visitors section.
export const VisitTracker = () => {
  const { pathname } = useLocation();
  const last = useRef(null);
  useEffect(() => {
    if (pathname.startsWith("/admin") || last.current === pathname) return;
    last.current = pathname;
    const first = !sessionStorage.getItem("jt-visit-session");
    sessionStorage.setItem("jt-visit-session", "1");
    const qs = new URLSearchParams(window.location.search);
    const utm = qs.get("utm_source") || "";
    api.post("/track/visit", { visitor_id: visitorId(), path: pathname.slice(0, 200), referrer: first ? document.referrer.slice(0, 500) : "", utm_source: utm.slice(0, 60), utm_campaign: (qs.get("utm_campaign") || "").slice(0, 60), new_session: first }).catch(() => {});
  }, [pathname]);
  return null;
};
